import React from 'react'

import {
  ColorBarContainer,
  ColorBarNamesColumn,
  ColorBarColorsColumn,
  ColorGradientBar,
  ColorScaleValueCellSimple, LegendBottomText, ColorBarContainerBottom,
} from './styled-elements'
import { metricDisplayStatuses } from "../../../reducers";

export default class RainbowLegendArrows extends React.Component {

  renderBody = ({ metricDisplayStatuses, unit }) => <div>
    <ColorBarContainer>
      <ColorBarNamesColumn style={{ justifyContent: 'space-between' }}>
        <ColorScaleValueCellSimple>100</ColorScaleValueCellSimple>
        <ColorScaleValueCellSimple>80</ColorScaleValueCellSimple>
        <ColorScaleValueCellSimple>60</ColorScaleValueCellSimple>
        <ColorScaleValueCellSimple>40</ColorScaleValueCellSimple>
        <ColorScaleValueCellSimple>20</ColorScaleValueCellSimple>
        <ColorScaleValueCellSimple>0</ColorScaleValueCellSimple>
      </ColorBarNamesColumn>
      <ColorBarColorsColumn>
        <ColorGradientBar
          height={150}
          colors={this.metricDisplayGradientColors()}
        />
      </ColorBarColorsColumn>
    </ColorBarContainer>
    <ColorBarContainerBottom>
      <LegendBottomText>in km/h</LegendBottomText>
    </ColorBarContainerBottom>
  </div>

  metricDisplayGradientColors() {
    const { metricDisplayStatuses } = this.props;
    let colors = [];

    if (metricDisplayStatuses.length === 0) {
      return colors;
    }

    let maxValue = metricDisplayStatuses[0].threshold_value;
    for (const mds of metricDisplayStatuses) {
      let pct = 100 - Math.round(100 * mds.threshold_value / maxValue);
      colors.push(mds.background_color + " " + pct + "%");
    }
    return colors;
  }

  metricDisplayStatusThreshold(position) {
    const { metricDisplayStatuses } = this.props;
    switch (position) {
      case 'top':
        return metricDisplayStatuses[0]?.threshold_value || 0;
      case 'bottom':
        return metricDisplayStatuses[metricDisplayStatuses.length - 1]?.threshold_value || 0;
      case 'middle':
        // find the metric display status closest to the mid value
        return (this.metricDisplayStatusThreshold("top") -
          this.metricDisplayStatusThreshold("bottom")) / 2;
      default:
        return null;
    }
  }

  render() {
    return this.renderBody(this.props);
  }
}
